import { render, staticRenderFns } from "./customerTransfer.vue?vue&type=template&id=0bfe2c48&scoped=true&"
import script from "./customerTransfer.vue?vue&type=script&lang=js&"
export * from "./customerTransfer.vue?vue&type=script&lang=js&"
import style0 from "./customerTransfer.vue?vue&type=style&index=0&id=0bfe2c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfe2c48",
  null
  
)

export default component.exports